import { useStoreMap } from 'effector-react'
import { $groups } from 'src/features/goods-groups-update/model'

export const useGroupById = (groupId: number) =>
    useStoreMap({
        store: $groups,
        keys: [groupId],
        fn: (groups, [id]) => {
            if (!groups || groups.length < 1) return
            return groups.find((x) => x.groupId === id)
        }
    })
